// extracted by mini-css-extract-plugin
export default {"inputContainer":"BirthDateInput_inputContainer__+I8QL"};